/**
 * Darstellung eines Zellwerts ohne Template — 1:1 zu einer `GridColumn` ohne `Format`:
 * ausgegeben wird der JSON-Wert als Text, verschachtelte Strukturen bleiben leer.
 */
export function toCellText(value: unknown): string {
  if (typeof value === 'string') return value;
  if (typeof value === 'number' || typeof value === 'boolean' || typeof value === 'bigint') {
    return String(value);
  }
  return '';
}

/** Dynamischer Feldzugriff wie im Altclient über `GridColumn.Field`. */
export function readField<T>(row: T, field: string): unknown {
  return (row as unknown as Record<string, unknown>)[field];
}
